<template>
  <div>
    <v-row align="center" dense>
      <v-col cols="12" sm="9" lg="10">
        <v-row align="center" dense>
          <v-col cols="12" sm="4">
            <v-select
              label="Succursales"
              hide-details
              multiple
              filled
              class="no-before"
              :items="getAvailablesStores"
              item-text="name_store"
              item-value="id_store"
              :value="store"
              @change="v => $emit('update:store', v)"
            >
              <template v-slot:selection="{ item, index }">
                <v-row align="center" justify="space-between" no-gutters>
                  <span v-if="index === 0">{{ item.name_store }}</span>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ store.length - 1 }})</span
                  >
                </v-row>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              label="Type"
              hide-details
              filled
              class="no-before"
              :items="typeChoices"
              :value="type"
              @change="v => $emit('update:type', v)"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="5" v-show="type === 'date'">
            <RangeDatePicker
              label="Période"
              hide-details
              filled
              no-before
              class="no-before"
              showOptionsMenu
              :value="dateRange"
              @input="v => $emit('update:dateRange', v)"
            ></RangeDatePicker>
          </v-col>
          <v-col cols="12" sm="5" v-show="type === 'event'">
            <v-autocomplete
              label="Évènement"
              hide-details
              filled
              class="no-before"
              :items="getUniqueNameEvents"
              item-text="name"
              item-value="id"
              :value="event"
              @change="v => $emit('update:event', v)"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="3" lg="2">
        <v-row align="center" justify="end" no-gutters class="mt-1">
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            large
            color="primary"
            elevation="0"
            @click="$emit('update')"
          >
            <v-icon small left>fa-sync-alt</v-icon>
            Actualiser</v-btn
          ></v-row
        >
      </v-col>
    </v-row>
    <v-row
      class="mt-2"
      v-if="type === 'date'"
      dense
      align="center"
      justify="space-between"
      no-gutters
    >
      <v-btn
        @click="prevPeriod"
        elevation="0"
        :small="$vuetify.breakpoint.smAndUp"
        :x-small="$vuetify.breakpoint.xsOnly"
      >
        <v-icon x-small left>fa-chevron-left</v-icon>
        Période précédente
      </v-btn>
      <v-btn
        @click="nextPeriod"
        elevation="0"
        :small="$vuetify.breakpoint.smAndUp"
        :x-small="$vuetify.breakpoint.xsOnly"
      >
        Période suivante
        <v-icon x-small right>fa-chevron-right</v-icon>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { RangeDatePicker } from "@/modules/Shared";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "DataFilter",
  components: {
    RangeDatePicker
  },
  props: {
    store: {
      required: true
    },
    type: {
      required: true
    },
    dateRange: {
      required: true
    },
    event: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getAvailablesStores", "getUniqueNameEvents"])
  },
  data() {
    return {
      typeChoices: [
        { value: "date", text: "Date" },
        { value: "event", text: "Évènement" }
      ]
    };
  },
  methods: {
    prevPeriod() {
      const start = moment(this.dateRange[0]);
      const end = moment(this.dateRange[1]);
      const diff = end.diff(start, "days") + 1;

      const newRange = [
        start.subtract(diff, "days").format("YYYY-MM-DD"),
        end.subtract(diff, "days").format("YYYY-MM-DD")
      ];
      this.$emit("update:dateRange", newRange);
      this.$emit("update");
    },
    nextPeriod() {
      const start = moment(this.dateRange[0]);
      const end = moment(this.dateRange[1]);
      const diff = end.diff(start, "days") + 1;

      const newRange = [
        start.add(diff, "days").format("YYYY-MM-DD"),
        end.add(diff, "days").format("YYYY-MM-DD")
      ];
      this.$emit("update:dateRange", newRange);
      this.$emit("update");
    }
  }
};
</script>

<style></style>
